export default __webpack_public_path__ + "static/media/3435 spice rack D side.384bf903.png";